import React from 'react';
import Select from 'react-select';

export const Dropdown = ({
  id,
  onChange,
  value = null,
  options = [],
  styles = undefined,
  isMulti = false,
  isSearchable = false,
  isClearable = false,
  isDisabled = false,
  placeholder = 'Please select...',
  className = '',
  classNamePrefix = '',
}) => (
  <Select
    value={value}
    onChange={(chosenOption) => {
      if (onChange) {
        onChange(chosenOption);
      }
    }}
    options={options}
    styles={styles}
    isMulti={isMulti}
    isSearchable={isSearchable}
    id={id ? `selectContainer-${id}` : ''}
    inputId={id ? `selectInput-${id}` : ''}
    placeholder={placeholder}
    isClearable={isClearable}
    isDisabled={isDisabled}
    className={className}
    classNamePrefix={classNamePrefix}
  />
);
